(() => {
  'use strict';
  const prices = Object.freeze({
    1: Object.freeze({once:6495, subscription:5846, bfOnce:5651, bfSubscription:5115}),
    2: Object.freeze({once:12341, subscription:11431, bfOnce:10782, bfSubscription:10002}),
    4: Object.freeze({once:23382, subscription:22083, bfOnce:20524, bfSubscription:19323}),
    8: Object.freeze({once:45725, subscription:41568, bfOnce:38970, bfSubscription:36372})
  });
  const savings = Object.freeze({
    regular: Object.freeze({once:[0,5,10,12],subscription:[10,12,15,20]}),
    black_friday: Object.freeze({once:[13,17,21,25],subscription:[21,23,25,30]})
  });
  function quote(pack, type, campaign) {
    const entry = prices[pack];
    if (!entry || !['once','subscription'].includes(type)) return null;
    const price = campaign === 'black_friday' ? entry[type === 'once' ? 'bfOnce' : 'bfSubscription'] : entry[type];
    const baseline = 6495 * Number(pack);
    const selectedMode = campaign === 'black_friday' ? 'black_friday' : 'regular';
    return Object.freeze({pack:Number(pack), type, price, baseline, saving:baseline-price, percent:savings[selectedMode][type][[1,2,4,8].indexOf(Number(pack))], renewal:type === 'subscription' ? entry.subscription : null});
  }
  function variantFromProduct(product, variantId) {
    const variant = (product.variants || []).find(item => String(item.id) === String(variantId));
    if (!variant) return null;
    const plans = new Map((product.selling_plan_groups || []).flatMap(group => group.selling_plans || []).map(plan => [String(plan.id), plan]));
    return {...variant, allocations: (variant.selling_plan_allocations || []).map(allocation => ({
      ...allocation,
      selling_plan: plans.get(String(allocation.selling_plan_id)) || null
    }))};
  }
  function eligibility(q, variant, config, native) {
    if (!q || !config.ready || native.currency !== 'USD' || !variant?.available) return null;
    if (config.productId && String(native.id) !== String(config.productId)) return null;
    if (q.type === 'once') return Number(variant.price) === q.price ? {variantId:variant.id,planId:null} : null;
    if (!config.cadence?.[q.pack]) return null;
    const interval = value => {
      const m=String(value||'').toLowerCase().match(/(\d+)?\s*(day|week|month|year)s?/);
      return m ? String(Number(m[1]||1))+':'+m[2] : null;
    };
    const expectedInterval=interval(config.cadence[q.pack]);
    if(!expectedInterval)return null;
    const allocation = (variant.allocations || []).find(a => {
      const adjustments = a.price_adjustments || [];
      const renewal = Number(adjustments[1]?.price ?? a.price);
      const plan=a.selling_plan;
      const actualInterval=(plan?.options||[]).map(o=>interval(o.value)).find(Boolean)||interval(plan?.name);
      const firstOnly=q.price===q.renewal||(adjustments.length>=2&&Number(plan?.price_adjustments?.[0]?.order_count)===1);
      return plan?.recurring_deliveries === true && actualInterval===expectedInterval && firstOnly && Number(a.price) === q.price && renewal === q.renewal;
    });
    return allocation ? {variantId:variant.id,planId:allocation.selling_plan.id} : null;
  }
  window.HSXOfferCore = Object.freeze({prices,quote,eligibility,variantFromProduct});
})();
